import React, { DragEvent } from 'react'

import RPath from 'ramda/src/path'
import { Block, Change } from 'slate'
import { getEventRange } from 'slate-react'

import StoryPreviewCard from '~/components/StoryPreviewCard'

import { Next, OnDropProps, RenderNodeProps, SerializeProps } from '../types'

// TO.DO: AP - These should be type 'document' and the data type should be story
export default {
  onDrop: (e: DragEvent, { editor }: OnDropProps, next: Next) => {
    const droppedData = e.dataTransfer.getData('data')

    if (!droppedData || JSON.parse(droppedData).type !== 'story') {
      return next()
    }

    const range = getEventRange(e, editor)
    if (!range) return next()

    return editor.change((change: Change) =>
      change.insertBlockAtRange(
        range,
        Block.create({
          type: 'story',
          data: JSON.parse(droppedData),
        })
      )
    )
  },

  renderNode: ({ node }: RenderNodeProps, next: Next) => {
    if (node.type !== 'story') return next()

    const data = node.data.toJS()

    const typeId = RPath<number>(['data', 'typeId'], data)
    if (!typeId) return next()

    return <StoryPreviewCard id={typeId} />
  },

  serialize: (obj: SerializeProps) => {
    if (obj.object === 'block' && obj.type === 'story') {
      return <p>Story needs more finnese</p>
    }
  },
}
